// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IAddOfferToComparisonRequest,
  TAddOfferToComparisonModel,
  IMappers,
  TAddOfferToComparisonResponse,
  IAddOfferToComparisonResponse,
  IAddOfferToComparisonResponseError,
} from './types';

export const defaultConfig: TAddOfferToComparisonModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'offers-comparison',
  pathApi: '/v2/add-offer-to-comparison/',
  requestType: 'json',
} as TAddOfferToComparisonModel;

export function createAddOfferToComparisonModel(parameters: IAddOfferToComparisonRequest): TAddOfferToComparisonModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddOfferToComparisonOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IAddOfferToComparisonRequest;
}

export async function fetchAddOfferToComparison<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddOfferToComparisonOptions<TResponse200, TResponse400>): Promise<
  TAddOfferToComparisonResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createAddOfferToComparisonModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddOfferToComparisonResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IAddOfferToComparisonResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TAddOfferToComparisonResponse;
}
